import type { SxProps } from "@mui/material/styles";
import type { TableCellProps } from "@mui/material/TableCell";
import TableCell from "@mui/material/TableCell";
import { useMemo } from "react";

import ExpandToggleIconButton from "./expand-toggle-icon-button.component";

type ExpandableTableCellProps = {
  open?: boolean;
  iconSx?: SxProps;
  isHidden?: boolean;
  setOpen?: (value: boolean) => void;
};
export default function ExpandableTableCell({
  open,
  isHidden,
  setOpen,
  iconSx,
  sx,
}: TableCellProps & ExpandableTableCellProps) {
  const cellSx = useMemo(
    () => ({ ...sx, display: isHidden ? "none" : undefined }),
    [isHidden, sx]
  );
  return (
    <TableCell sx={cellSx}>
      <ExpandToggleIconButton
        open={open}
        iconSx={iconSx}
        onToggle={() => setOpen?.(!open)}
      />
    </TableCell>
  );
}
